import { Fragment } from 'react'
import { useNavigate } from 'react-router-dom'
import type { StepDef } from '../flow/steps'
import { useTranslation } from '../localization/useTranslation'
import { IconCheck } from '../ui/icons'

interface StepperProps {
  steps: StepDef[]
  activeIndex: number
}

/**
 * Dot progress stepper (mockup `.stepper`). Completed steps show a check and are clickable to
 * go back; the active step is filled with a wash ring. Labels collapse to bare dots on narrow
 * embeds via base.css.
 */
export function Stepper({ steps, activeIndex }: StepperProps) {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <nav className="stepper" aria-label="Trade-in progress">
      {steps.map((step, i) => {
        const done = i < activeIndex
        const active = i === activeIndex
        const cls = `stp ${done ? 'done' : ''} ${active ? 'active' : ''}`.trim()

        return (
          <Fragment key={step.id}>
            <button
              type="button"
              className={cls}
              aria-current={active ? 'step' : undefined}
              disabled={!done}
              onClick={() => done && navigate(`/${step.path}`)}
            >
              <span className="dot">{done ? <IconCheck /> : i + 1}</span>
              <span className="lbl">{t(step.label)}</span>
            </button>
            {i < steps.length - 1 && <span className="stp-bar" aria-hidden />}
          </Fragment>
        )
      })}
    </nav>
  )
}
